// extracted by mini-css-extract-plugin
module.exports = {"buttonStyle":"AddButton_buttonStyle__2x-6R"};